export default function ({ ssoHost, oaHost }) {
	return {
		searchUser: `//${oaHost}/employee/list`,
		getUserInfo: `//${ssoHost}/queryuserbytoken/`,
	};
}
